/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

// 👇 adicione isto:
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { appConfig } from './app/app.config';


bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
